// extracted by mini-css-extract-plugin
module.exports = {"main":"Taskbar_main__10ObA","expander":"Taskbar_expander__1q1L3","logo":"Taskbar_logo__25nGb"};